export default {
	insert: {
		id: 'Please enter your ID',
		pw: 'Please enter your Password',
	},

	find: {
		id: 'Find ID',
		pw: 'Find Password',
	},

	filter: {
		filter: 'Filter',
		all: 'All',
		add: 'Add',
		delete: 'Delete',
		modify: 'Modify',
	},

	header: {
		alarm: {
			allRead: 'Mark all as read',
			noAlarm: 'No new notifications.',
			leftComment: '{name} left a comment.',
			leftSignatureRequest: '{name} requested a signature.',
			signatureRequest: '{name} requested a signature.',
			time: 'Today',
			yesterday: 'Yesterday',
			minutesAgo: '{n} min ago',
			hoursAgo: '{n} hr ago',
			daysAgo: '{n} days ago',
			avatarAlt: 'Profile photo',
			timeAgo: 'Time ago',
			dayAgo: 'Day ago',
			weekAgo: 'Week ago',
			monthAgo: 'Month ago',
			yearAgo: 'Year ago',
		},
	},

	modal: {
		title: 'Alarm',
		message: 'Are you sure you want to delete this?',
		serverError: 'An error occurred. Please try again later.',
		signature: {
			title: 'Signature',
			upload: 'Upload',
			draw: 'Draw',
			uploadDescription: 'Use the Select File button to select a file directly',
			selectFile: 'Select File',
			drawDescription: 'Put your signature here',
			reset: 'Reset',
			undo: 'Undo',
			redo: 'Redo',
			save: 'Save',
			close: 'Close',
			invalidExtension: 'Invalid file extension. Only image files can be uploaded.',
			multipleFiles: 'Only one file can be uploaded.',
		},
		fileUpload: {
			noFile: 'No file uploaded. Please try again.',
			noExtension: 'Please check the file extension.',
			noFileName: 'File name not found. Please try again.',
			sizeExceeded: 'File size exceeds 1MB. Please upload a file smaller than 1MB.',
		},
		save: 'Saving is complete.',
		signatureCancel: 'The signature has been canceled.',
		block: 'Please select a block.',
		file: 'Please select a file.',
		date: 'Please select a date.',
		select: 'Please select.',
		retry: 'Please try again later.',
		projectList: {
			terminate: 'The project has been completed.',
			delete: 'The current note has been deleted.',
			create: 'The project has been created.',
			createError: 'An error occurred while creating a note.\n Please try again.',
			saveOut: 'There are unsaved changes.\nUnsaved changes will be lost.\nDo you want to save?',
			save: 'The content has been saved.',
			title: 'Project name is required.',
			participant: 'Please assign participants.',
			approver: 'Please assign approvers.',
			viewer: 'Please assign viewers.',
			createProject: 'The project has been created.',
			update: 'The project has been modified.',
			errDuplicate: 'Project name is already in use.',
			errDefault: 'An error occurred while creating a project.\n Please try again.',
			msgTerminate: 'Are you sure you want to exit?',
			errNoteDelete: 'Note participants cannot be excluded from project participants.',
			errProjectUpdate: 'An error occurred while modifying the project.\n Please try again.',
			errFileOver: 'You can upload up to 100 files.',
			errFileSize: 'File size exceeds 10GB.',
		},

		templateList: {
			create: 'The template has been created.',
			createError: 'An error occurred while creating a note.\n Please try again.',
			saveOut: 'There are unsaved changes.\nUnsaved changes will be lost.\nDo you want to save?',
			save: 'The content has been saved.',
			delete: 'Are you sure you want to delete the template?',
			title: 'Template name is required.',
			participant: 'Please assign participants.',
			approver: 'Please assign approvers.',
			viewer: 'Please assign viewers.',
			update: 'The template has been modified.',
			errDuplicate: 'Template name duplication error.',
			errDefault: 'An error occurred while creating a template.\n Please try again.',
			msgTerminate: 'Are you sure you want to exit?',
			templateLeaderRequired: 'Please select the template leader.',
		},

		uploadImg: 'Only images smaller than 3MB can be uploaded.',
		uploadFile: 'Only files smaller than 50MB can be uploaded.',
		selectFile: 'Please select only JPG, JPEG, PNG, or GIF files.',
		selectFileExtension: 'Please select only xls,xlsx,pptx,pdf,docx,txt,zip,rar,tar,odt.',
		optionList: {
			chart: {
				type: 'Type',
				create: 'Create Chart',
				labelWarn: 'The label name is required.',
				dataWarn: 'The data name is required.',
				negativeWarn: 'Charts cannot be created with negative values.',
				auto: 'Automatic',
				data: 'Data',
				y: 'The Y-axis label name.',
				x: 'The X-axis label name.',
				color: 'Color',
				horizontal: 'Horizontal',
				vertical: 'Vertical',
				title: 'Chart Name',
				warn: 'Please enter the chart name.',
				placeholderList: {
					y: 'Please enter the Y-axis label.',
					x: 'Please enter the X-axis label',
					data: 'Data Name',
					label: 'Label',
				},
				noTable: 'There is no table available to create a chart.',
				select: 'Please select a table first to create a chart.',
				multi: 'To generate a chart, you must specify multiple ranges instead of a single range.',
			},
			date: {
				warn: 'You cannot add a date to the currently selected block.',
			},
		},
		position: 'Please reassign the position.',
		range: 'You cannot add a date to the currently selected text. Please change the range.',
		dropbox: {
			enterText: 'Please enter at least one code and name.',
			emptyCode: ' row code is empty.',
			emptyName: ' row name is empty.',
			sameCode: 'The same code cannot be used.',
		},
		schema: {
			required: 'field and value are required.',
			enterTxt: 'The schema is required.',
			emptyField: 'line Schema field is empty.',
			emptyValue: 'line Schema value is empty.',
			emptyName: 'line Schema name is empty.',
			sameName: 'The same schema name cannot be used.',
		},
		template: {
			create: 'The template has been created.',
			version: 'Approved.',
			verWarn: 'This version cannot be approved.',
			approve: 'Template Approval',
			approveConfirm: 'Do you want to approve this template?',
			approveNeedSave: 'You have unsaved changes. Please save before approving.',
			tempData: 'There is currently saved temporary data.',
			delete: 'Do you want to approve after deleting',
			deleteAlarm: 'An error occurred while deleting the template.',
			saveErrorMessage: 'An error occurred while saving the template.',
		},
		user: {
			email: 'Please enter a valid email address.',
			phone: 'Please enter a valid phone number.',
			modifyInfo: 'The information has been updated.',
		},
		myPage: {
			name: 'Name',
			email: 'Email',
			phone: 'Phone',
			department: 'Department',
			placeholder: {
				name: 'Please enter your name.',
				phone: 'Please enter your phone number.',
				email: 'Please enter your email address.',
			},
			required: 'Please enter all required information.',
			retrieve: { success: 'My info retrieved successfully.' },
			update: { success: 'Information has been updated.' },
			upload: {
				drawsignature: { failure: 'An error occurred while uploading the drawn signature.' },
				jsonparsing: { failure: 'An error occurred while parsing JSON.' },
				notfounddrawsignature: { failure: 'Drawn signature not found.' },
				notfoundsignature: { failure: 'Signature not found.' },
				profile: { failure: 'An error occurred while uploading the profile.' },
				signature: { failure: 'An error occurred while uploading the signature.' },
			},
		},

		session: {
			autoLogout: (minute: number | null | undefined) =>
				`${!minute ? '1 minute' : `${minute} seconds`} after automatic logout. If you want to extend the login time, please click the renew button.`,
			autoLogoutTerminate: 'Logged out. Please log in again.',
			terminate: 'The session has ended.',
		},
		searchResult: 'No results found.',
		error: {
			title: 'Error',
			template: 'Template Error',
			project: 'Project Error',
			department: 'Department Error',
			minimumLength: 'Please enter at least 2 characters.',
			searchError: 'An error occurred while searching.',
			participant: 'An error occurred while retrieving the participant list.',
			list: 'An error occurred while retrieving the data list.',
			user: 'An error occurred while retrieving the user list.',
			departmentSearch: 'An error occurred while retrieving the department list.',
			priority: 'An error occurred while retrieving the priority list.',
			schema: 'An error occurred while retrieving the schema list.',
			schemaCreate: 'An error occurred while creating the schema.',
			schemaSave: 'An error occurred while saving the schema.',
			signature: 'An error occurred while retrieving the signature list.',
			signatureUpload: 'An error occurred while uploading the signature.',
			signatureCancel: 'An error occurred while canceling the signature.',
			signatureComplete: 'An error occurred while completing the signature.',
			noSignature: 'No signature found. Please add a signature.',
			noteSave: 'An error occurred while saving the note.',
			logout: 'Logout failed. Please try again.',
			searchType: 'Please select a search type.',
			userUpdate: 'An error occurred while saving the user permission.',
			schemaListType: 'Schema type name is required.',
			licenseUpdate: 'An error occurred while updating the license.',
			dropbox: 'An error occurred while retrieving the dropbox list.',
			projectCloseAlarm: 'All notes in the project must be closed to close the project.',
			projectOpenAlarm: 'The project is currently in progress. Resuming is only possible when the status is Closed.',
			projectCloseServerError: 'An error occurred during the project closing process.',
			projectOpenServerError: 'An error occurred during the project reopening process.',
			emptyTitle: 'Title is required.',
			duplicateTitle: 'Title is duplicated.',
			htmlTag: 'HTML tags cannot be included.',
			reviewFind: 'An error occurred while retrieving the review list.',
			projectLeaderFind: 'An error occurred while retrieving the project leader information.',
			note: 'An error occurred while retrieving the note.',
			noteUid: 'Note UID is not found.',
			userInfo: 'User information is not found.',
			dateRange: 'Please set the start date before the end date.',
			downloadError: 'An error occurred while downloading.',
			roleNotFound: (roleName: string) => `Role ${roleName} not found in roleList.`,
			templateDeleteAlarm: 'An error occurred while deleting the template.',
			templateApprove: 'An error occurred while approving the template.',
			templateListRetrieve: 'Failed to load the list.',
			blockTypeFile: 'Files can only be added to text blocks.',
			blockTypeImage: 'Images can only be added to text blocks.',
			blockTypeTable: 'Tables can only be added to text blocks.',
			blockTypeCalendar: 'Dates can only be added to text blocks.',
			blockTypeChart: 'Charts can only be added to table blocks.',
			latexEmpty: 'Empty values cannot be saved.',
		},
		preview: 'Preview',
		projectCloseAlarm: 'All notes in the project must be closed to close the project.',
		success: {
			userUpdate: 'The user permission has been saved.',
			licenseUpdate: 'The license has been updated.',
			signatureRequest: 'The signature request has been sent.',
			downloadSuccess: 'Download completed.',
		},
		noChange: 'No changes have been made.',
		licenseRevoke: 'Do you want to revoke the license?',
	},
	mypage: {
		retrieve: { success: 'My information has been retrieved.' },
	},
	menu: {
		dashboard: 'Dashboard',
		project: 'Project',
		template: 'Template',
		schema: 'Schema',
		dropbox: 'Dropbox',
	},

	sign: {
		in: 'Login',
		up: 'Sign Up',
		find: {
			id: 'Find ID',
			pw: 'Find Password',
		},
		id: 'ID (Email)',
		pw: 'Password',
		rePw: 'Verify Password',
		save: 'Save ID',
		out: 'Sign Out',
		hide: 'Hide Password',
		show: 'Show Password',
		ing: 'Logging in...',
		checkList: {
			input: 'Please enter your ID and password.',
			retry: 'Please try logging in again.',
			email: 'Please enter the registered email address.',
		},
		err: {
			employee: 'Employee lookup error. Please try again.',
			token: 'Token issuance error. Please try again.',
			login_fall: 'Login failed. Please check your ID and password.',
			server_failure: 'Login failed due to a server issue.',
		},
		service: {
			terms: 'Service Terms',
			privacy: 'Privacy Policy',
		},
	},

	user: {
		id: 'User ID',
	},

	// 기존 사용 department 데이터는 주석처리
	// Audit action keys convenience mapping
	// department: { updateuser: { success: 'The user permission has been saved.' } },
	// moved license success keys under ui.license below to avoid duplication

	department: {
		detail: {
			user: 'User Info',
			info: 'Detail Info',
			role: 'Role List',
			default: 'Default Role',
		},
		group: {
			info: 'Group Member',
			select: 'Select Department',
			groupName: 'Group Name',
			groupLeader: 'Group Leader',
			groupMember: 'Group Member',
			groupMemberSelect: 'Select Group Member',
			name: 'Name(ID)',
		},
		modal: {
			updateSuccess: 'The department information has been updated successfully.',
			updateFailure: 'The department information has been updated unsuccessfully.',
		},
	},

	note: {
		closed: { success: 'The note has been closed.' },
		signature: { success: 'The note has been signed.', revoke: 'The note has been revoked.', error: 'The note has been revoked unsuccessfully.' },
		create: { success: 'The note has been created.', existstitle: { failure: 'The note title already exists.' } },
		update: { success: 'The note has been updated.', notinprogress: { failure: 'The note is in progress of signing. It cannot be modified.' } },
		save: { success: 'The note has been saved.' },
		retrieve: { notexists: { failure: 'The note does not exist.' } },
		allComplete: 'All signatures have been completed.',
	},

	designation: '',

	dashboard: {
		info: 'Hello.',
		project: 'Project',
		joinProject: 'Ongoing Projects',
		template: 'Template',
		schema: 'Schema',
		dropbox: 'Drop Box',
		endableProject: 'Closable Project',
		closedProject: 'Closed Project',
		item: 'item(s)',
		asset: 'Asset',
	},

	table: {
		thumbnail: 'Thumbnail',
		no: 'No',
		priority: 'Priority',
		title: 'Title',
		dropboxTitle: 'Title',
		userNm: 'Name',
		userId: 'ID',
		code: 'Code',
		email: 'Email',
		phone: 'Phone',
		poster: 'Poster',
		updatedUserId: 'Updater',
		createDt: 'Date of Registration',
		updateDt: 'Last Modified Date',
		loginDt: 'Last Login Date',
		version: 'Version',
		more: 'View More',
		status: 'Status',
		description: 'Description',
		statusCodeI: 'Progress',
		statusCodeF: 'Completion',
		statusCodeY: 'Used',
		statusCodeN: 'Not Used',
		actionType: 'Action',
		none: 'No results',
		content: 'Data is not currently registered',
		signatureList: 'signatureList',
		endDay: 'Deadline',
		required: 'Required',
		uniqueValue: 'Unique Value',
		name: 'Name',
		basic: 'Basic',
		use: 'Use',
		unUse: 'Unused',
		type: 'Type',
		create: 'Create Table',
		createError: 'At least 1 row/column must be specified when creating a table.',
		createMaxError: 'You can create up to 30 rows/columns when initially creating a table.',
		addMaxError: 'You can add up to 100 rows/columns to a table.',
		department: 'Department',
		userCreateDt: 'Registration Date',
		revokeDt: 'Revoke Date',
		renewDt: 'Renewal Date',
		expireDt: 'Expiration Date',
		schemaCellSizeError: 'The number of cells is smaller than the schema size being added.\nPlease increase the number of cells to add the schema.',
		schemaDeleteConfirm: 'There are rows containing a schema.\nIf you continue, the schema rows will also be deleted.\nDo you want to continue?',
	},

	search: {
		select: 'Select',
		placeholder: 'Please enter a search term',
		search: 'Search',
		total: 'Total',
		new: 'Create New',
		type: 'Select Type',
		year: 'Year',
		month: 'Month',
		day: 'Day',
		startDate: 'Start Date',
		endDate: 'End Date',
		createDate: 'Create',
		modifyDate: 'Modify',
		desc: 'Desc',
		asc: 'Asc',
		clear: 'Clear',
		close: 'Close',
		typeList: {
			unknownUser: 'Unknown User',
			title: 'Title',
			userId: 'Poster',
			description: 'Description',
			type: 'Type name',
			status: 'Status',
			name: 'Name',
			id: 'ID',
			role: 'Role',
			employee: 'Employee Number',
			email: 'Email',
			phone: 'Contact information',
			department: 'Department Name',
			executives: 'Executives and Employees',
			noteName: 'Lab Note Name',
		},
		pageSizeList: {
			10: '10 items',
			20: '20 items',
			50: '50 items',
			100: '100 items',
		},
		placeholderList: {
			department: 'Please enter Department Name',
			participate: 'Please enter Participating Researcher',
			date: 'Please enter the date',
			type: 'Please specify the type.',
			select: 'Please select a department name or employee name.',
			version: 'Please select a version.',
			label: 'Please enter the label.',
			unique: 'Please enter the unique value.',
			basic: 'Please enter the basic value.',
			selectBasic: 'Please select the basic value.',
			description: 'Please enter the description.',
		},
	},

	file: {
		attachments: 'Attachment File',
		item: 'item(s)',
	},

	button: {
		cancel: 'Cancel',
		create: 'Create',
		back: 'Back',
		modify: 'Modify',
		termination: 'Project Termination',
		signature: 'Signature',
		save: 'Save',
		approval: 'Approval',
		delete: 'Delete',
		allDelete: 'Delete All',
		history: 'History',
		audit: 'Audit Trail',
		close: 'Close',
		confirm: 'Confirm',
		apply: 'Apply',
		unsign: 'Unsign',
		end: 'End',
		logout: 'Logout',
		add: {
			schema: 'Add Schema',
			text: 'Add',
			template: 'Add Template',
		},
		csv: 'CSV File Upload',
		sync: 'Sync',
		thumbnail: 'Change Thumbnail',
		checkin: 'Check-in',
		use: 'Use',
		ok: 'OK',
		refresh: 'Refresh',
		closeAll: 'Close All',
		revoke: 'Revoke',
		assign: 'Assign',
		renew: 'Renew',
	},

	sort: {
		desc: 'Descending Order',
		asc: 'Ascending Order',
		createAt: 'Registration Date Order',
	},

	project: {
		modal: {
			create: 'Create Project',
			modify: 'Modify Project',
			title: 'Project Title',
			description: 'Description',
			setParticipant: 'Set Participants',
			priority: 'Priority',
			projectLeader: 'Project Leader',
			placeholder: {
				title: 'Please enter the project name.',
				name: 'Please enter the project name.',
				description: 'Please enter the project description.',
				projectLeader: 'Please select the project leader.',
				priority: 'Please select the priority.',
			},
			departmentName: 'Department Name',
			templateAdd: 'Add Template',
		},

		name: 'Project Name',
		description: 'Description',
		department: 'Department',
		participate: 'Participating Researcher',
		setting: 'setting',
		select: 'Please select a project.',
		placeholder: {
			name: 'Please enter Project Name',
			description: 'Please enter Project Description',
		},

		err: {
			name: 'Please enter Project Name',
		},

		create: {
			existstitle: { failure: 'The project title already exists.' },
		},

		note: {
			create: 'Create Note',
			existstitle: { failure: 'The note title already exists.' },
			name: 'Note Name',
			template: 'Template',
			edit: 'Edit Note',
			placeholder: {
				name: 'Please enter Note Title',
				description: 'Please enter Note Description',
			},

			err: {
				name: 'Please enter Note Name',
			},

			status: {
				progress: 'Progress',
				reviewing: 'Reviewing',
				pending: 'Pending',
				closed: 'Closed',
				new: 'New',
			},

			sideMenu: {
				auditTrail: 'Audit Trail',
				setting: 'Setting Project',
				signNote: 'Sign Note',
				endProject: 'End Project',
				confirmEndProject: 'A closed project cannot be edited.',
				noteSetting: 'Note Setting',
				noteCreate: 'Add Note',
				reopenProject: 'Reopen Project',
				confirmReopenProject: 'Closed status will be cleared and the project can be edited again.',
			},

			signature: {
				title: 'Signature',
				approve: 'Approve',
				etc: 'Etc',
				sign: 'Approve',
				load: 'Load Signature',
				request: 'Request Signature',
				requestAll: 'Request All Signatures',
				unsign: 'Revoke Signature',
				confirmSubmit: 'Do you want to sign?',
				confirmAccuracy: 'I confirm that the above record is accurate and I am signing accordingly.',
				confirmReviewContent: 'I have reviewed the electronic lab notebook content for this version and confirm that the records contain no omissions or errors.',
				confirmAckRequired: 'Please check all of the above items before confirming.',
				imageUnavailable: 'Signature image URL is not available.',
				noRevisionForSign: 'Signing is not allowed because there is no note revision history.',
			},
		},

		empty: {
			add: 'Please create a note by clicking the Create Note button',
			finish: "It's a completed project",
			select: 'Please select a project',
		},

		table: {
			name: 'Table',
			create: 'Create',
			max: 'Max',
			err: {
				create: 'You can create 1 to 30 pieces',
			},
			alarmList: {
				create: 'You cannot create a table within a table.',
				max: 'The maximum table size is 30×30.',
				lastRow: 'The last row cannot be deleted.',
				lastCol: 'The last column cannot be deleted',
				dropbox: 'You can create a new one after deleting the existing dropbox box.',
				boxCreate: 'A dropbox cannot be created in this cell.',
				select: 'No table has been selected.\n Please try again.',
			},
		},
		signature: {
			complete: 'The signature has been completed.\n Edits are not allowed.\n If you need to make changes, please request the project leader to remove the signature.',
			modify: ' is editing.',
			warn: 'No one has signed as a reviewer.\n To close the note, at least one person must sign as a reviewer.\n Please remove your signature and sign as a reviewer, \n or add a new member and have them sign as a reviewer.',
		},
		terminate: 'This project has been closed.',
		admin: 'You do not have permission to create a note.',
	},

	sideMenu: {
		left: 'Left aligned',
		center: 'Center aligned',
		right: 'Right aligned',
		cut: 'Cutting Image',
		captionAdd: 'Add Caption',
		captionRemove: 'Remove Caption',
		delete: 'Delete',
		modifyChart: 'Modify Chart',
		review: 'Review',
		modifyReview: 'Modify Review',
		deleteReview: 'Delete Review',
		blockAdd: 'Add Block',
	},

	context: {
		rowTitle: 'Specify subject row',
		columnTitle: 'Specify subject column',
		rowTitleRemove: 'Remove subject row',
		columnTitleRemove: 'Remove subject column',
		left: 'Add column to the left',
		right: 'Add column to the right',
		up: 'Add a row up',
		down: 'Add a row down',
		merge: 'Merge Cells',
		unmerge: 'Unmerge Cells',
		removeMerge: 'Unmerge Cells',
		deleteCol: 'Delete a column',
		deleteRow: 'Delete Row',
		dropbox: 'Create Dropbox',
		asset: 'Add Asset',
		image: 'Insert Image',
		comment: 'Add Comment',
	},

	options: {
		header: {
			h1: 'A grand title',
			h2: 'Medium title',
			h3: 'Subheading',
			h4: 'Content',
			h5: 'Description',
			h6: 'Reference',
		},
		bold: 'Bold',
		italic: 'Italic',
		strikethrough: 'Strike Through',
		underline: 'Underline',
		superscript: 'Superscript',
		subscript: 'Subscript',
		color: 'Text Color',
		bg: 'Text Background Color',
		fontSize: 'Font Size',
		fontChange: 'Change Font',
		add: {
			table: 'Add table',
			image: 'Add image',
			calendar: 'Add Date',
			chart: {
				text: 'Add Chart',
				bar: 'Bar Chart',
				horizontal: 'Horizontal Chart',
				line: 'Line Chart',
				doughnut: 'Doughnut Chart',
				pie: 'Pie Chart',
				radar: 'Radar Chart',
				scatter: 'Scatter',
				yTitle: 'y-axis label name',
				xTitle: 'x-axis label name',
			},
		},
		upload: 'File Upload',
		download: 'PDF Download',
	},

	schema: {
		titleList: {
			title: 'Title',
			description: 'Description',
			list: 'List',
			type: 'Type',
			version: 'Version',
			schemaTypeCode: 'Schema Type Code',
			schemaTypeName: 'Schema Type Name',
			new: 'New Schema',
		},
		placeholderList: {
			titlePlaceholder: 'Please enter the title.',
			schemaTypeCode: 'Please enter the schema code.',
			schemaTypeName: 'Please enter the schema type name.',
			description: 'Please enter the schema description.',
			schemaName: 'Please enter the schema name.',
			field: 'Please enter the schema field.',
			value: 'Please enter the schema value (Within 200 characters)',
			unique: 'Please enter the unique value.',
			basic: 'Please enter the basic value.',
			selectBasic: 'Please select the basic value.',
		},
		modal: {
			create: 'The schema has been created.',
			modify: 'The schema has been modified.',
			schemaTypeCode: 'Schema code is required.',
			schemaTypeName: 'Schema type name is required.',
			schemaTitle: 'Schema title is required.',
			schemaContent: 'Schema content is required.',
			schemaUnique: 'Schema unique value is required.',
			schemaField: 'Schema field is required.',
			schemaValue: 'Schema value is required.',
			schemaFieldAndValue: 'Please enter the schema field and value.',
			schemaName: 'Schema name is required.',
			schemaLabelRequired: 'Name is required.',
			schemaListRequired: 'Schema list is required.',
			required: 'Required value is required.',
			schemaDuplicate: 'Schema title is already in use.',
			schemaDropbox: 'Please create a dropbox first.',
			schemaListType: 'Schema type name is required.',
			schemaDropboxDefault: 'Schema dropbox default is required.',
		},
		radio: {
			use: 'Use',
			unused: 'Unused',
		},
		error: {
			unique: 'Unique value cannot be duplicated.',
			maxLength: 'Please enter up to 200 characters.',
			maxCount: 'The schema list can be created up to 50 pieces.',
			blockMaxCount: 'You can add up to 30 field/value rows.',
			cannotDeleteExisting: 'Existing schemas cannot be deleted.',
		},
		create: {
			success: 'The schema has been created.',
			server: { failure: 'An error occurred while creating the schema.' },
			title: { failure: 'Schema title is required.' },
			uniquevalue: { failure: 'The unique value is duplicated.' },
		},
		retrieve: { existstitle: { failure: 'Schema title already exists.' } },
		save: {
			success: 'The schema has been saved.',
			server: { failure: 'An error occurred while saving the schema.' },
			uniquevalue: { failure: 'The unique value is duplicated.' },
		},
	},

	dropbox: {
		select: 'Please select a dropbox.',
		defaultPlaceholder: 'Select',

		info: {
			status: 'Status',
			active: 'Active',
			inActive: 'Inactive',
			version: 'Version',
			versionPlaceholder: 'Select Version',
			title: 'Title',
			titlePlaceholder: 'Please enter the title.',
			description: 'Description',
			descriptionPlaceholder: 'Please enter the description.',
			placeHolder: 'Placeholder',
			placeHolderPlaceholder: 'Please enter the placeholder.',
			titleRequired: 'Title is required.',
			titleDuplicate: 'Title is already in use.',
			save: 'Save',
		},
		item: {
			list: 'List',
			code: 'Code',
			value: 'Value',
			default: 'Default',
			codePlaceholder: 'Please enter the code.',
			valuePlaceholder: 'Please enter the value.',
			codeWarn: 'The code is required.',
			valueWarn: 'The value is required.',
			codeRequired: 'The code is required.',
			valueRequired: 'The value is required.',
			codeDuplicate: 'Two codes cannot have the same name.',
			active: 'Active',
			inActive: 'Inactive',
			create: 'Create',
			status: 'Status',
		},
		right: {
			noSelect: 'No selected value.',
			select: 'Please select a list on the left to view the details.',
			active: 'Active',
			inActive: 'Inactive',
			default: 'Default',
			noDefault: 'No Default',
		},
		create: {
			success: 'The dropbox has been created.',
			codeduplicate: { failure: 'The code is duplicated.' },
			existscode: { failure: 'The code already exists.' },
			existstitle: { failure: 'The title already exists.' },
			server: { failure: 'An error occurred while creating the dropbox.' },
		},
		save: {
			success: 'The dropbox has been saved.',
			codeduplicate: { failure: 'The code is duplicated.' },
			server: { failure: 'An error occurred while saving the dropbox.' },
		},
		error: {
			maxLength: 'Cannot exceed 200 characters.',
			defaultRequired: 'Default value is required.',
		},
	},

	template: {
		modal: {
			create: 'Create Template',
			modify: 'Modify Template',
			title: 'Template Name',
			description: 'Description',
			templateLeader: 'Template Leader',
			templateNameRequired: 'Template Name is required.',
			placeholder: {
				title: 'Please enter the template name.',
				name: 'Please enter the template name.',
				description: 'Please enter the template description.',
				templateLeader: 'Please select the template leader.',
			},
		},
		sideMenu: {
			auditTrail: 'Audit Trail',
			setting: 'Setting Template',
			approve: 'Approve Template',
		},
		select: 'Please select a template.',
		approve: {
			success: 'The template has been approved.',
			server: { failure: 'An error occurred while approving the template.' },
		},
		checkin: {
			success: 'Checked in successfully.',
			usebyanotheruser: { failure: 'Used by another user.' },
		},
		checkout: { success: 'Checked out successfully.' },
		save: {
			success: 'The template has been saved.',
			server: { failure: 'An error occurred while saving the template.' },
			block: { failure: 'Please select the block first.' },
			table: { failure: 'Invalid table state.' },
			notfoundtemplate: { failure: 'Template not found.' },
		},
		status: { change: { failure: 'Failed to change the status.' } },
		update: {
			success: 'The template has been updated.',
			server: { failure: 'An error occurred while updating the template.' },
			notfoundtemplate: { failure: 'Template not found.' },
		},
		create: {
			success: 'The template has been created.',
			existstitle: { failure: 'The template title already exists.' },
			server: { failure: 'An error occurred while creating the template.' },
		},
	},

	admin: {
		menu: {
			project: 'Project',
			template: 'Template',
			schema: 'Schema',
			dropbox: 'Dropbox',
		},
		access: 'User permissions',
		id: 'ID',
		name: 'Name',
		number: 'Employee number',
		companyName: 'Company Name',
		placeholder: {
			userId: 'Please enter the user ID.',
			companyName: 'Please enter the company name.',
			departmentName: 'Please enter the department name.',
			createDt: 'Please enter the registration date and time.',
			loginDt: 'Please enter the last login date.',
		},
		departmentName: 'Department Name',
		positionName: 'Position Name',
		email: 'Email',
		phone: 'Phone Number',
		date: 'Registration Date and Time',
		loginDt: 'Last Login Date',
		department: 'department',
		employees: 'Employees and Executives',
		emailFormat: 'Please enter a valid email address.',
		role: {
			Name: 'Role',
			roleSet: 'Role Setting',
			roleList: 'Role List',
			roleDepartment: 'Department Role',
			roleAddDelete: 'Role Add and Delete',
			employeeRoleGroup: 'Employee Role Group',
			createRoleGroup: 'Create Role Group',
			deleteRoleGroup: 'Delete Role Group',
		},
	},

	license: {
		title: 'Product License Information',
		licenseName: 'License Name',
		status: 'License Status',
		ver: 'Version',
		endDate: 'Expiration Date',
		maxCapacity: 'Maximum Capacity',
		update: 'Update Date',
		assign: { success: 'The license has been assigned.' },
		revoke: { success: 'The license has been revoked.' },
		count: 'Active User Count',
	},

	pagination: {
		prev: 'Prev',
		next: 'Next',
	},

	notFound: {
		title: 'This Page Not Found',
		message: 'This requested page was not found',
		home: 'Return home',
	},

	userModal: {
		user: 'Assign User',
		approver: 'Assign Approver',
		viewer: 'Assign Viewer',
		license: 'Assign License',
	},
	asset: {
		select: 'Select a menu',
	},

	tab: {
		new: 'New Tab',
	},

	review: {
		now: 'Just now',
		min: 'minute ago',
		hour: 'hour ago',
		day: 'day ago',
		month: 'month ago',
		year: 'year ago',
		modify: 'Modify comment',
		delete: 'Delete comment',
	},

	// Audit natural language templates
	auditText: {
		ipSuffix: ' ip({ip})',
		user: {
			update: {
				success: '{user} information has been updated.',
			},
		},
		login: {
			success: '{user} logged in successfully.{ipSuffix}',
			failure: '{user} failed to log in.{ipSuffix}',
		},
		note: {
			create: '{note} note has been created.',
			save: '{note} note has been saved.',
			update: '{note} note has been updated.',
			closed: '{note} note has been closed.',
			signature: {
				success: 'Signature completed for {note} note.',
				failure: 'Failed to process signature for {note} note.',
			},
		},
		project: {
			create: '{project} project has been created.',
			save: '{project} project has been saved.',
			update: '{project} project has been updated.',
			closable: '{project} project can be closed.',
			closed: '{project} project has been closed.',
			opened: '{project} project has been opened.',
		},
		template: {
			create: '{template} template has been created.',
			save: '{template} template has been saved.',
			update: '{template} template has been updated.',
			approve: '{template} template has been approved.',
			checkin: '{template} template has been checked in.',
			checkout: '{template} template has been checked out.',
		},
		dropbox: {
			create: '{dropbox} dropbox has been created.',
			save: '{dropbox} dropbox has been saved.',
		},
		schema: {
			create: '{schema} schema has been created.',
			save: '{schema} schema has been saved.',
		},
		license: {
			assign: '{userId} has assigned license {assignedLicenseName} to {assignedUsers}.',
			revoke: '{userId} has revoked license {revokedLicenseName} from {revokedUsers}.',
		},
		department: {
			updateuser: 'The user permission has been saved.',
		},
	},

	auth: {
		login: {
			userid: {
				failure: 'Login failed.',
			},
			success: 'Login success',
			failure: 'Login failed.',
			password: { failure: 'The password does not match.' },
		},
		logout: {
			success: 'Logout success',
			confirm: 'Do you want to log out?',
			failure: 'Logout failed. Please try again.',
		},
	},

	ai: {
		title: 'AI Assistant',
		model: 'Model',
		apiKey: 'API Key',
		apiKeyPlaceholder: 'Enter Gemini API key',
		inputPlaceholder: 'Enter your message... (Enter to send)',
		send: 'Send',
		clear: 'Clear',
		empty: 'Start a conversation with the AI assistant.',
		ollamaNoModels: 'No models found',
		includeEditor: 'Include editor content',
		analyze: 'Analyze editor',
		analyzePrompt: 'Please summarize and analyze the content above.',
		copy: 'Copy',
		copied: 'Copied!',
	},
}
